<modal-container
  #modal
  [headerTitle]="'bulk.edit'"
  [headerIconClass]="'far-edit'"
  [isExtraLargeModal]="!isShowingProgress"
  [isLargeModal]="true"
  [ignoreBackdropClick]="true"
>
  <ng-container class="modal-button-show">
    <btn
      [label]="'bulk.edit'"
      [title]="'bulk.edit' | translate"
      [classes]="['btn-third', 'float-right', 'me-2']"
      [icon]="'far-edit'"
      [btnType]="'button'"
      (click)="showChildModal()"
      [attr.data-cy]="dataCyAttribute"
    >
    </btn>
  </ng-container>

  <ng-container class="modal-body-content">
    @if (!isShowingProgress) {
      <div class="flex-column">
        <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
        <div class="flex-gap-10 flex-row">
          <div class="flex-column w-50">
            <div class="card">
              <div class="font-weight">
                {{ 'expedition' | translate }}
              </div>
              <div>
                <form-row-input
                  [label]="'dateExpedition'"
                  [icon]="'fa-calendar'"
                  [inputType]="'date'"
                  [(model)]="orderChanges.dateExpedition"
                  [inputRequired]="true"
                  [dataCyAttribute]="'modal-bulk-edits.order-dateExpedition-select'"
                ></form-row-input>
              </div>
              <div>
                <form-row-select
                  [label]="'priority'"
                  [(model)]="orderChanges.priority"
                  [options]="priorityOptions"
                  [dataCyAttribute]="'modal-bulk-edits.order-priority-select'"
                ></form-row-select>
              </div>
            </div>
            <div class="card">
              <div class="font-weight">
                {{ 'payment' | translate }}
              </div>
              <div>
                <form-row-select
                  [label]="'carrier'"
                  [icon]="'far-shipping-fast'"
                  [(model)]="orderChanges.carrier"
                  [bindToObject]="true"
                  [options]="carrierOptions()"
                  [dataCyAttribute]="'order-carrier'"
                >
                </form-row-select>
              </div>
              <div class="flex-gap-1">
                <form-row-select
                  class="w-50"
                  [label]="'payment.type'"
                  [icon]="'far-money-check-alt'"
                  [options]="paymentOptions()"
                  [(model)]="paymentSelectedOption"
                  [bindToObject]="true"
                  [dataCyAttribute]="'order-payment'"
                >
                </form-row-select>
                <form-row-select
                  class="w-50"
                  [label]="'isPaid'"
                  [options]="isPaidOptions"
                  [(model)]="isPaidSelectedOption"
                  [bindToObject]="true"
                  [dataCyAttribute]="'order-payment'"
                >
                </form-row-select>
              </div>
            </div>
            <div class="card">
              <form-row-checkbox
                [isInBulkEdits]="true"
                [label]="'bulk-edits-orders.bulk-delete'"
                [(ngModel)]="deleteOrders"
                [name]="'bulk-edits-orders.bulk-delete'"
                [dataCySelector]="'deleteOrders-checkbox'"
              >
              </form-row-checkbox>
            </div>
          </div>
          <div class="w-50">
            <div class="card">
              <div class="font-weight">
                {{ 'tags' | translate }}
              </div>
              <div>
                <form-row-select [title]="'tags'" [(model)]="tagSelectedOption" [options]="selectOptions">
                </form-row-select>
              </div>
              @for (tag of tags; track tag) {
                <div>
                  <form-row-checkbox
                    [isInBulkEdits]="true"
                    [label]="tag?.name"
                    [model]="getTagValue(tag)"
                    (modelChange)="updateTags(tag, $event)"
                    [cursorPointer]="true"
                    [dataCySelector]="'tag-checkbox'"
                  >
                  </form-row-checkbox>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (isShowingProgress) {
      <div class="card">
        <div class="progressbar-div justify-content-space-around">
          <div>
            <progress
              [ngClass]="isProgressFinish ? 'progress-finish' : 'progress-loading'"
              class="progress-bar-2"
              role="progressbar"
              [max]="numberOfAllOrders"
              [value]="numberOfUpdatedOrders"
            ></progress>
            @if (updating) {
              <div class="text-align-center">{{ numberOfUpdatedOrders + '/' + numberOfAllOrders }}</div>
            }
            @if (isProgressFinish) {
              <div class="font-weight done text-align-center">
                {{ 'done' | translate }}
                <i class="fa fa-check"></i>
              </div>
            }
          </div>
          @if (isShowingProgress && !isProgressFinish) {
            <btn
              [label]="'suspend'"
              [title]="'suspend' | translate"
              [icon]="'far fa-ban'"
              [classes]="['btn-first']"
              (onEvent)="suspend()"
            >
            </btn>
          }
        </div>
        <div class="d-flex">
          @if (ordersWithoutPaymentItems && ordersWithoutPaymentItems.length > 0) {
            <div class="mt-2">
              {{ 'modal-bulk-edits.ordersWithoutPaymentItem.warning' | translate }}
              @for (o of ordersWithoutPaymentItems; track o) {
                <ul class="list-unstyled">
                  <li>
                    <a [routerLink]="['/order', o.id]">{{
                      ('order' | translate) + '&nbsp; ' + (o.reservationNumber ? o.reservationNumber : '')
                    }}</a>
                  </li>
                </ul>
              }
            </div>
          }
          @if (ordersWithMorePaymentItems?.length > 0) {
            <div class="mt-2">
              {{ 'modal-bulk-edits.ordersWithMorePaymentItem.warning' | translate }}
              @for (o of ordersWithMorePaymentItems; track o) {
                <ul class="list-unstyled">
                  <li>
                    <a [routerLink]="['/order', o.id]">{{
                      ('order' | translate) + '&nbsp; ' + (o.reservationNumber ? o.reservationNumber : '')
                    }}</a>
                  </li>
                </ul>
              }
            </div>
          }
          @if (updateErrors?.length > 0) {
            <div class="error-list-div">
              <hr />
              <div class="font-weight text-center margin-bottom-10">
                {{ 'failed.to.edit' | translate }}
              </div>
              @for (err of updateErrors; track err) {
                <div class="error-message-div">
                  <a class="link order-reservationNumber" [routerLink]="['/order', err.orderId]">
                    {{ err.orderReservationNumber }}
                  </a>
                  <div class="error-message">{{ err.errMessage }}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </ng-container>
  <ng-container class="modal-footer-content">
    @if (!isShowingProgress) {
      <btn
        [label]="'edit'"
        [title]="'edit' | translate"
        [icon]="'far-check'"
        [classes]="['btn-first']"
        (onEvent)="save()"
        [dataCyAttribute]="'bulk-edits-submit'"
      ></btn>
    }
  </ng-container>
</modal-container>
